/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { useLazyBackground } from '../../Hooks/use-lazy-background';

const LazyBackground = ({
  children,
  image375,
  image768,
  image992,
  image1200,
  image1400,
  image1800,
  style = {},
  className = '',
}) => {
  const ref = useRef(null);

  const getBackgroundUrl = width => {
    if (width >= 1800 && image1800) return image1800;
    if (width >= 1400 && image1400) return image1400;
    if (width >= 1200 && image1200) return image1200;
    if (width >= 992 && image992) return image992;
    if (width >= 768 && image768) return image768;
    return image375;
  };

  const [backgroundUrl, setBackgroundUrl] = useState(() => {
    if (typeof window !== 'undefined') {
      return getBackgroundUrl(window.innerWidth);
    }
    return image375;
  });

  useLazyBackground();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const newBackgroundUrl = getBackgroundUrl(width);

      setBackgroundUrl(prev => {
        if (prev !== newBackgroundUrl) {
          return newBackgroundUrl;
        }
        return prev;
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [image375, image768, image992, image1200, image1400, image1800]); // eslint-disable-line

  useEffect(() => {
    if (ref.current) {
      ref.current.dataset.bg = backgroundUrl;
      ref.current.style.backgroundImage = `url('${backgroundUrl}')`;
    }
  }, [backgroundUrl]);

  return (
    <div
      ref={ref}
      data-bg={backgroundUrl}
      className={`lazy-background ${className}`}
      style={{
        ...style,
        backgroundSize: 'cover',
        backgroundColor: '#f0f0f0',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {children}
    </div>
  );
};

export default LazyBackground;
